import { createAction } from 'redux-actions';

export const getTrips = createAction('GET_TRIPS');
export const getTripsSuccess = createAction('GET_TRIPS_SUCCESS');
export const getTripsFailure = createAction('GET_TRIPS_FAILURE');

export const createTrip = createAction('CREATE_TRIP', (payload) => payload, (payload, metadata) => metadata);
export const createTripSuccess = createAction('CREATE_TRIP_SUCCESS', (payload) => payload, (payload, metadata) => metadata);
export const createTripFailure = createAction('CREATE_TRIP_FAILURE');

export const updateTrip = createAction('UPDATE_TRIP', (payload) => payload, (payload, metadata) => metadata);
export const updateTripSuccess = createAction('UPDATE_TRIP_SUCCESS');
export const updateTripFailure = createAction('UPDATE_TRIP_FAILURE');

export const deleteTrip = createAction('DELETE_TRIP', (payload) => payload, (payload, metadata) => metadata);
export const deleteTripSuccess = createAction('DELETE_TRIP_SUCCESS');
export const deleteTripFailure = createAction('DELETE_TRIP_FAILURE');
